import {useRouteMatch} from 'react-router-dom'

import {getPageUrlPattern} from '../common/navigation'
import {PathParams} from '../declarations'

export const usePlantParameter = (): string => {
  const match = useRouteMatch<Pick<PathParams, 'plant'>>(getPageUrlPattern('plantsHome'))
  return match?.params.plant ?? ''
}
